import React from "react";
import PropTypes from "prop-types";

export const CategoryIcon = () => {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.25" y="3.25" width="35.5" height="35.5" rx="17.75" fill="white" />
      <rect x="3.25" y="3.25" width="35.5" height="35.5" rx="17.75" stroke="black" strokeWidth="0.5" />
      <path
        d="M19.5 19.5H14.25V14.25H19.5V19.5ZM19.5 22.5H14.25V27.75H19.5V22.5ZM27.75 14.25H22.5V19.5H27.75V14.25ZM25.125 22.5C24.6058 22.5 24.0983 22.654 23.6666 22.9424C23.2349 23.2308 22.8985 23.6408 22.6998 24.1205C22.5011 24.6001 22.4492 25.1279 22.5504 25.6371C22.6517 26.1463 22.9017 26.614 23.2688 26.9812C23.636 27.3483 24.1037 27.5983 24.6129 27.6996C25.1221 27.8008 25.6499 27.7489 26.1295 27.5502C26.6092 27.3515 27.0192 27.0151 27.3076 26.5834C27.596 26.1517 27.75 25.6442 27.75 25.125C27.75 24.4288 27.4734 23.7611 26.9812 23.2688C26.4889 22.7766 25.8212 22.5 25.125 22.5Z"
        fill="black"
      />
    </svg>
  );
};

CategoryIcon.propTypes = {
  color: PropTypes.string,
};
